// Per-company + per-period text overrides.
// Any labeled string in the investor report can be overridden by an admin
// via an EditableText primitive. Keys are opaque strings chosen by the
// caller — section titles use `section-title:<sectionId>` for example.

const STORAGE_PREFIX = 'finkloz_text_';
const CHANGE_EVENT = 'finkloz:text-overrides-changed';

function storeKey(companyId, period) {
  return `${STORAGE_PREFIX}${companyId || 'default'}_${period || 'default'}`;
}

function readAll(companyId, period) {
  try {
    const raw = localStorage.getItem(storeKey(companyId, period));
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeAll(companyId, period, obj) {
  try {
    localStorage.setItem(storeKey(companyId, period), JSON.stringify(obj));
    window.dispatchEvent(new Event(CHANGE_EVENT));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('writeAll text overrides failed', e);
  }
}

export function getTextOverride(companyId, period, key) {
  const all = readAll(companyId, period);
  return Object.prototype.hasOwnProperty.call(all, key) ? all[key] : undefined;
}

export function setTextOverride(companyId, period, key, value) {
  const all = readAll(companyId, period);
  all[key] = value;
  writeAll(companyId, period, all);
}

export function clearTextOverride(companyId, period, key) {
  const all = readAll(companyId, period);
  if (Object.prototype.hasOwnProperty.call(all, key)) {
    delete all[key];
    writeAll(companyId, period, all);
  }
}

export function subscribeToTextOverrideChanges(callback) {
  const handler = () => callback();
  window.addEventListener(CHANGE_EVENT, handler);
  window.addEventListener('storage', handler);
  return () => {
    window.removeEventListener(CHANGE_EVENT, handler);
    window.removeEventListener('storage', handler);
  };
}
